// extracted by mini-css-extract-plugin
export default {"layout":"AuthFormLayout_layout__F+aac"};